import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../../../public/img/logo_widget1.png';
import _imports_1 from '../../../../public/img/tool_ios.png';
import _imports_2 from '../../../../public/img/tool_android.png';
const _hoisted_1 = {
  class: "px-6 py-2"
};
import { computed } from 'vue';
import LinkService from '@/services/LinkService';
import MainHeader from '@/components/MainHeader.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'UserTools',
  setup(__props) {
    const os = computed(() => {
      const {
        userAgent,
        platform
      } = navigator;
      const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
      const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
      const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
      if (macosPlatforms.includes(platform)) return 'Mac';
      if (iosPlatforms.includes(platform)) return 'iOS';
      if (windowsPlatforms.includes(platform)) return 'Windows';
      if (/Android/.test(userAgent)) return 'Android';
      if (/Linux/.test(platform)) return 'Linux';
      return undefined;
    });
    function openDesktop() {
      let url = '';
      const isProd = isProduction();
      switch (os.value) {
        case 'Mac':
          url = isProd ? LinkService.links.macTracker : LinkService.links.previewMacTracker;
          break;
        case 'Windows':
          url = isProd ? LinkService.links.windowsTracker : LinkService.links.previewWindowsTracker;
          break;
        default:
          alert('The desktop tracker is not available for your platform.');
          return;
      }
      // this is intended to look what we are downloading
      window.open(url, '_blank');
    }
    const openIOs = () => window.open('https://itunes.apple.com/us/app/leanlaw/id1128609356?ls=1&mt=8', '_blank');
    const openAndroid = () => window.open('https://play.google.com/store/apps/details?id=co.leanlaw.mobile', '_blank');
    function isProduction() {
      return !/^(test|devfe)\./.test(window.location.hostname);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(MainHeader, {
        content: "Tools for Tracking Time"
      }), _cache[12] || (_cache[12] = _createElementVNode("p", null, " These tools can help you capture time. We have a desktop app and a mobile app that you can use in addition to tracking time on the LeanLaw website. ", -1)), _createElementVNode("table", null, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[1] || (_cache[1] = _createElementVNode("td", null, [_createElementVNode("img", {
        src: _imports_0,
        width: "60"
      })], -1)), _cache[2] || (_cache[2] = _createElementVNode("td", null, [_createElementVNode("h3", null, "LeanLaw Desktop Tracker")], -1)), _createElementVNode("td", null, [_createVNode(LlSecondaryButton, {
        "track-click": "External:Tracker",
        onBtnClick: openDesktop
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" install ", -1)]))]),
        _: 1
      })])]), _cache[9] || (_cache[9] = _createElementVNode("tr", null, [_createElementVNode("td"), _createElementVNode("td", {
        colspan: "2"
      }, [_createTextVNode(" Desktop time tracker for easily generating time entries including timers. "), _createElementVNode("br"), _createTextVNode(" Windows and macOS only. "), _createElementVNode("hr")])], -1)), _createElementVNode("tr", null, [_cache[4] || (_cache[4] = _createElementVNode("td", null, [_createElementVNode("img", {
        src: _imports_1,
        width: "60"
      })], -1)), _cache[5] || (_cache[5] = _createElementVNode("td", null, [_createElementVNode("h3", null, "LeanLaw for iOS")], -1)), _createElementVNode("td", null, [_createVNode(LlSecondaryButton, {
        "track-click": "External:iOS",
        onBtnClick: openIOs
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" install ", -1)]))]),
        _: 1
      })])]), _cache[10] || (_cache[10] = _createElementVNode("tr", null, [_createElementVNode("td"), _createElementVNode("td", {
        colspan: "2"
      }, [_createTextVNode(" LeanLaw mobile app for iOS for tracking time "), _createElementVNode("hr")])], -1)), _createElementVNode("tr", null, [_cache[7] || (_cache[7] = _createElementVNode("td", null, [_createElementVNode("img", {
        src: _imports_2,
        width: "60"
      })], -1)), _cache[8] || (_cache[8] = _createElementVNode("td", null, [_createElementVNode("h3", null, "LeanLaw for Android")], -1)), _createElementVNode("td", null, [_createVNode(LlSecondaryButton, {
        "track-click": "External:Android",
        onBtnClick: openAndroid
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" install ", -1)]))]),
        _: 1
      })])]), _cache[11] || (_cache[11] = _createElementVNode("tr", null, [_createElementVNode("td"), _createElementVNode("td", {
        colspan: "2"
      }, [_createTextVNode(" LeanLaw mobile app for Android for tracking time "), _createElementVNode("hr")])], -1))])])]);
    };
  }
};